import { render } from "./ListaProdotti.vue?vue&type=template&id=30eb440f"
import script from "./ListaProdotti.vue?vue&type=script&lang=js"
export * from "./ListaProdotti.vue?vue&type=script&lang=js"

import "./ListaProdotti.vue?vue&type=style&index=0&id=30eb440f&lang=css"

import exportComponent from "/Users/mattia/Desktop/Projects/elbi-website-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__